import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as models from 'app/models';
import * as services from 'app/services';
import * as viewmodels from 'app/viewmodels';
import { DateFilterOption, DateFilterOptionEnum } from '../../models/enumerations';

@Component({
    selector: 'app-filter-set-save-dialog',
    templateUrl: './filter-set-save-dialog.component.html',
    styleUrls: ['./filter-set-save-dialog.component.scss'],
    standalone: false
})
export class FilterSetSaveDialogComponent implements OnInit {

  filterSet: models.FilterSet;
  saving: boolean = false;

  includeHarvests: boolean = false;
  includeGroups: boolean = false;

  groups: models.Group[] = [];
  zones: models.Zone[] = [];
  teams: models.Team[] = [];
  users: models.User[] = [];
  taskTypes: viewmodels.MultiSelect[] = [];

  forAnalytics: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<FilterSetSaveDialogComponent>
    , @Inject(MAT_DIALOG_DATA) public data: any
    , private filterSetService: services.FilterSetService
    , private helperService: services.HelperService
    , private groupService: services.GroupService
    , private zoneService: services.ZoneService
    , private teamService: services.TeamService
    , private userService: services.UserService
    , private taskTypeService: services.TaskTypesService
    , private notifierService: services.NotifierService
  ) { 
    this.filterSet = data;
  }

  ngOnInit(): void {
    this.loadGroups();
    this.loadZones();
    this.loadTeams();
    this.loadUsers();
    this.loadTaskTypes();
  }

  async loadGroups() {
    this.groups = await this.groupService.getAllModels();
  }

  async loadZones() {
    this.zones = await this.zoneService.getAll();
  }

  async loadTeams() {
    this.teams = await this.teamService.getAllModels();
  }

  async loadUsers() {
    const companyId: string = this.helperService.currentCompanyId;
    this.users = await this.userService.getUsersForCompanyWithCaching(companyId, true, true);
  }

  async loadTaskTypes() {
    this.taskTypes = await this.taskTypeService.loadTaskTypes();
  }

  groupShowmore: boolean = false;
  get showGroupSummary() {
    return this.filterSet.groupIds != null;
  }
  get groupSummary() {
    if(this.groups.length == 0 || !this.filterSet.groupIds?.length) {
      return 'None';
    }
    return this.groups.filter(i => this.filterSet.groupIds.includes(i.uid)).map(i => i.name).join(', ');
  }

  zoneShowmore: boolean = false;
  get showZoneSummary() {
    return this.filterSet.zoneIds != null;
  }
  get zoneSummary() {
    if(this.zones.length == 0 || !this.filterSet.zoneIds?.length) {
      return 'All';
    }
    return this.zones.filter(i => this.filterSet.zoneIds.includes(i.id)).map(i => i.name).join(', ');
  }

  phaseShowmore: boolean = false;
  get showPhaseSummary() {
    return this.filterSet.phases != null;
  }
  get phaseSummary() {
    if(this.filterSet.phases.length == 0) {
      return 'All';
    }
    return this.filterSet.phases.join(', ');
  }

  teamShowmore: boolean = false;
  get showTeamSummary() {
    return this.filterSet.teamIds != null;
  }
  get teamSummary() {
    if(this.teams.length == 0 || !this.filterSet.teamIds?.length) {
      return 'All';
    }
    return this.teams.filter(i => this.filterSet.teamIds.includes(i.uid)).map(i => i.name).join(', ');
  }

  userShowmore: boolean = false;
  get showUserSummary() {
    return this.filterSet.userIds != null;
  }
  get userSummary() {
    if(this.users.length == 0 || !this.filterSet.userIds?.length) {
      return 'All';
    }
    return this.users.filter(i => this.filterSet.userIds.includes(i.id)).map(i => i.displayName).join(', ');
  }

  tagShowmore: boolean = false;
  get showTagSummary() {
    return this.filterSet.tags != null;
  }
  get tagSummary() {
    if(this.filterSet.tags.length == 0) {
      return 'All';
    }
    return this.filterSet.tags.join(', ');
  }

  private getDateRangeDisplayName(rangeType: string): string {
    switch (rangeType) {
      case DateFilterOptionEnum.LastWeek:
        return 'Last Week';
      case DateFilterOptionEnum.LastMonth:
        return 'Last Month';
      case DateFilterOptionEnum.LastQuarter:
        return 'Last Quarter';
      case DateFilterOptionEnum.LastYear:
        return 'Last Year';
      case DateFilterOptionEnum.AllTime:
        return 'All Time';
      case DateFilterOptionEnum.Custom:
        return `${this.helperService.timestampToFormattedDateString(this.filterSet.dateRange.startDate)} - ${this.helperService.timestampToFormattedDateString(this.filterSet.dateRange.endDate)}`;
      default:
        return rangeType;
    }
  }

  get showDateRangeSummary() {
    return this.filterSet.dateRange != null;
  }

  get dateRangeSummary() {
    return this.getDateRangeDisplayName(this.filterSet.dateRange.rangeType);
  }

  taskTypeShowmore: boolean = false;
  get showTaskTypeSummary() {
    return this.filterSet.taskTypeIds != null;
  }
  get taskTypeSummary() {
    if(this.taskTypes.length == 0 || !this.filterSet.taskTypeIds?.length) {
      return 'None';
    }
    return this.taskTypes.filter(i => this.filterSet.taskTypeIds.includes(i.id)).map(i => i.displayValue).join(', ');
  }

  isEllipsisActive(e) {
    return (e.offsetWidth < e.scrollWidth);
  }

  async save() {
    // if(!this.includeHarvests){
    //   delete this.filterSet.harvestIds
    // }
    // if(!this.includeGroups){
    //   delete this.filterSet.groupIds
    // }
    if(this.filterSet.name == null || this.filterSet.name == ''){
      this.notifierService.error('Please enter a name for the filter set');
      return;
    }

    this.saving = true;
    let id = await this.filterSetService.save(this.filterSet)
    this.dialogRef.close(id);
    this.saving = false;
  }
}